import AlertCircle from "@uui/AlertCircle";

import { IntegrationDetailContent } from "@app/analytics/Integrations/styles";
import LINKS from "@app/common/links";

import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import Link from "@rui/Link";

const IntegrationError = () => (
  <IntegrationDetailContent padding={2} flex={1}>
    <EmptyStateContainer backgroundColor="transparent.white.50">
      <EmptyStateIcon Icon={AlertCircle} type="error" />
      <EmptyStateTitle>Oops!</EmptyStateTitle>
      <EmptyStateSubtext>
        Unable to fetch integration details at this time. Please try again later
        or reach out to <Link href={LINKS.EMAIL.SUPPORT}>support@read.ai</Link>{" "}
        if the problem persists.
      </EmptyStateSubtext>
    </EmptyStateContainer>
  </IntegrationDetailContent>
);

export default IntegrationError;
